/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import PromotionOrderDetail from "./Components/PromotionOrderDetail";
import ProductItem from "./Components/ProductItem";
import FooterWrapper from "./Components/FooterWrapper";
import useStyles from "./styles";

import {
	getOrderHistoryDetailsAction,
	setOrderHistoryDetailsAction
} from "store/actions/OrderPageAction";
import { connect } from "react-redux";
import { Grid } from "@material-ui/core";
import { useHistory } from "react-router-dom";

const OrderHistoryDetailPage = props => {
	const {
		getOrderHistoryDetails,
		listOrderHistoryDetails,
		setOrderHistoryDetails
	} = props;

	const classes = useStyles();
	const history = useHistory();
	const heightFooter = document.getElementById(
		"footerHistoryOrderDetail"
	)?.offsetHeight;
	const heightHeaderPage =
		document.getElementById("headerPage")?.offsetHeight;

	const height = heightHeaderPage + heightFooter;
	const idNotification = new URLSearchParams(history.location.search).get(
		"id"
	);
	const businessUrl = new URLSearchParams(history.location.search).get(
		"business"
	);

	useEffect(() => {
		return () => {
			setOrderHistoryDetails({});
		};
	}, []);

	useEffect(() => {
		if (!!idNotification && !!businessUrl) {
			const data = {
				business: businessUrl,
				id: idNotification
			};
			getOrderHistoryDetails(data);
		} else {
			history.push("/home");
		}
	}, [idNotification, businessUrl]);

	return (
		<Grid
			classes={{ root: classes.root }}
			style={{
				height: `calc(100vh - ${height}px)`
			}}
		>
			<Grid classes={{ root: classes.rootPage }}>
				{listOrderHistoryDetails?.orderItems &&
					listOrderHistoryDetails?.orderItems?.map(product => (
						<ProductItem key={product?.id} product={product} />
					))}
				{listOrderHistoryDetails?.giftByCampaigns &&
					listOrderHistoryDetails?.giftByCampaigns?.map(
						(giftByCampaign, index) => (
							<PromotionOrderDetail
								key={index}
								giftByCampaign={giftByCampaign}
							/>
						)
					)}
			</Grid>
			<FooterWrapper listOrderHistoryDetails={listOrderHistoryDetails} />
		</Grid>
	);
};

const mapStateToProps = state => {
	return {
		listOrderHistoryDetails: state.orderPageReducer.listOrderHistoryDetails
	};
};

const mapDispatchToProps = dispatch => {
	return {
		getOrderHistoryDetails: data => {
			dispatch(getOrderHistoryDetailsAction(data));
		},
		setOrderHistoryDetails: data => {
			dispatch(setOrderHistoryDetailsAction(data));
		}
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(OrderHistoryDetailPage);
